<template>
  <div class="articles">
    <h1 class="title">{{ category.title }}</h1>
    <div>
      <ul class="list pa0 ma0">
        <li class="mb3" v-for="article in paginatedOrders" :key="article.name">
          <button
            class="article-button"
            :class="{
              'article-button--active': openArticleIds.includes(article.id)
            }"
          >
            <a
              :data-article="article.id"
              @click.prevent="showArticle"
              style="color: inherit; text-decoration: inherit;"
              v-bind:href="`#${article.source_id}-${article.title.replace(/ /g, '-')}`"
              >{{ article.title }}</a
            >
          </button>
          <div :id="`art-${article.id}`" class="article-body">
            <div v-html="article.body" data-external="articles"></div>
          </div>
        </li>
      </ul>
      <div class="container">
        <button @click="loadMore" v-if="currentPage * maxPerPage < articles.length" class="button__show-more">
          Show more
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M3 4.5l2.6 2.6c.2.2.5.2.7 0L9 4.5"></path></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getStorage, replaceMaHcLoginSupportContent, getSpecificArticleFromStore } from '@/utils/common';
export default {
  props: {
    name
  },
  data() {
    return {
      openArticleIds: [],
      currentPage: 1,
      maxPerPage: 20,
    };
  },
  updated() {
    replaceMaHcLoginSupportContent();
  },
  methods: {
    handleArticleClick(id) {
      if (this.openArticleIds.includes(id)) {
        let index = this.openArticleIds.indexOf(id);

        this.openArticleIds.splice(index, 1);
      } else {
        this.openArticleIds.push(id);
      }
    },
    showArticle(e) {
      let articleId = e.target.dataset.article;
      let element = document.querySelector(`#art-${articleId}`);
      if (this.openArticleIds.includes(articleId)) {
        element.style['max-height'] = `0px`;
        element.classList.remove('active');
        this.handleArticleClick(articleId);
        return;
      }
      element.style['max-height'] = `${element.scrollHeight}px`;
      element.style['transition'] = '0.5s';
      this.handleArticleClick(articleId);
      element.classList.add('active');
      this.activeArticle = articleId;
    },
    loadMore() {
      this.currentPage += 1;
    }
  },
  computed: {
    pageTitle() {
      const pageTitle = this.name;
      return pageTitle;
    },
    category() {
      const name = this.$store.state.categories[this.$route.meta.categoryId];
      return name;
    },
    articles() {
      const faq_1 = getSpecificArticleFromStore('4402562474900') || {};
      const faq_2 = getSpecificArticleFromStore('8913861027604') || {};
      const faq_3 = getSpecificArticleFromStore('8913868313748') || {};
      const faq_4 = getSpecificArticleFromStore('8913928666260') || {};
      const faq_5 = getSpecificArticleFromStore('8913908785684') || {};
      const faq_6 = getSpecificArticleFromStore('360061126572') || {};
      const faq_7 = getSpecificArticleFromStore('8913965231636') || {};
      const faq_8 = getSpecificArticleFromStore('8913967568148') || {};
      const faq_9 = getSpecificArticleFromStore('8914003910420') || {};
      const faq_10 = getSpecificArticleFromStore('8914006051988') || {};
      const faq_11 = getSpecificArticleFromStore('8914011456660') || {};
      const faq_12 = getSpecificArticleFromStore('8914064520980') || {};
      const faq_13 = getSpecificArticleFromStore('8914072705684') || {};
      const faq_14 = getSpecificArticleFromStore('360061125312') || {};
      const faq_15 = getSpecificArticleFromStore('8914074705428') || {};
      const faq_16 = getSpecificArticleFromStore('360061126372') || {};
      const faq_17 = getSpecificArticleFromStore('360061126532') || {};
      const faq_18 = getSpecificArticleFromStore('360061533631') || {};
      const faq_19 = getSpecificArticleFromStore('4402563023124') || {};
      const faq_20 = getSpecificArticleFromStore('4402563114132') || {};
      const faq_21 = getSpecificArticleFromStore('8914078793492') || {};

      return [
        faq_1,
        faq_2,
        faq_3,
        faq_4,
        faq_5,
        faq_6,
        faq_7,
        faq_8,
        faq_9,
        faq_10,
        faq_11,
        faq_12,
        faq_13,
        faq_14,
        faq_15,
        faq_16,
        faq_17,
        faq_18,
        faq_19,
        faq_20,
        faq_21
      ];
    },
    paginatedOrders() {
      return this.articles.slice(0, this.currentPage * this.maxPerPage);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/lsweepshc-design.scss';
.articles {
  .title {
    margin-bottom: 0.2rem;
    font-size: 32px;
  }
}

.article-button {
  color: $theme-highlight;
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
  transition: 0.1s linear color;
  padding: 0.2rem 0;
  width: 100%;

  a {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
  &:hover {
    color: #b4b4b4;
  }
  &--active {
    margin: 0;
  }
}
.article-body {
  // -webkit-transition: max-height 0.3s cubic-bezier(0, 1, 0, 1); /* For Safari 3.1 to 6.0 */
  transition: 1s;
  max-height: 0px;
  overflow: hidden;
  font-size: 14px;
  font-family: Roboto, Helvetica, Arial, sans-serif;

  a {
    color: $theme-highlight;
    text-decoration: none;
  }
}
.container {
  display: flex;
}
.button__show-more {
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: #3bb4ef;
    flex: 1 1 auto;
    text-align: center;
    margin: 0;
    padding: 0;

    &:hover {
      background-color: transparent;
      color: #3bb4ef;
      text-decoration: underline;
    }

  svg {
    display: inline-block;
    margin-left: 1px;
    vertical-align: middle;
  }
}
</style>
